import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-6 col-lg-8" }
const _hoisted_3 = { class: "table table-hover align-middle" }
const _hoisted_4 = { class: "border-dark border-bottom pb-2" }
const _hoisted_5 = { class: "border-dark border-bottom" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  colspan: 4,
  class: "fw-bold small text-uppercase text-muted"
}
const _hoisted_10 = { class: "is-active" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "auth-token fst-italic" }
const _hoisted_14 = { class: "buttons" }
const _hoisted_15 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_16 = ["onClick", "data-dp-tooltip"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["onClick", "data-dp-tooltip"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "link_off", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "col-12 col-md-6 col-lg-4" }
const _hoisted_23 = { class: "card mb-4" }
const _hoisted_24 = { class: "card-header" }
const _hoisted_25 = { class: "card-title mb-0" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("ul", { class: "list-group list-group-flush" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "list-group-item" }, "Payconiq")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_BaseIconIsActive = _resolveComponent("BaseIconIsActive")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_PaymentProviderSettings = _resolveComponent("PaymentProviderSettings")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: "Payconiq",
          mb: 4,
          "show-refresh-button": "",
          onRefresh: this.reloadContent,
          "back-route": {name: 'pharma-pay'}
        }, null, 8, ["onRefresh"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_AlertError2, {
              error: this.paymentProvidersUI.getError()
            }, null, 8, ["error"]),
            _createElementVNode("table", _hoisted_3, [
              _createElementVNode("thead", _hoisted_4, [
                _createElementVNode("tr", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('paymentProvider')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('authenticationToken')), 1),
                  _hoisted_7
                ])
              ]),
              _createElementVNode("tbody", null, [
                (this.paymentProvidersUI.isNotReady())
                  ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                      key: 0,
                      "n-cols": 4
                    }))
                  : _createCommentVNode("", true),
                (this.paymentProvidersUI.isReady() && !this.hasPaymentProviders)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                      _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$t('noContentFound')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (this.paymentProvidersUI.isReady() && this.hasPaymentProviders)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(this.paymentProviders, (paymentProvider) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: paymentProvider.code
                      }, [
                        _createElementVNode("td", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_BaseIconIsActive, {
                              "is-active": this.getPaymentProviderSettings(paymentProvider.code)?.is_active ?? false
                            }, null, 8, ["is-active"])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(paymentProvider?.description), 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(this.getPaymentProviderSettings(paymentProvider.code)?.auth_token), 1),
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("button", {
                              onClick: _withModifiers(($event: any) => (this.openPaymentProviderSettings(paymentProvider)), ["prevent"]),
                              class: "btn btn-icon btn-primary mx-1",
                              "data-dp-tooltip": _ctx.$t('edit'),
                              "data-dp-position": "left"
                            }, _hoisted_18, 8, _hoisted_16),
                            (this.getPaymentProviderSettings(paymentProvider.code)?.auth_token)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: _withModifiers(($event: any) => (this.disconnectPaymentProvider(paymentProvider.code)), ["prevent"]),
                                  class: "btn btn-icon btn-danger mx-1",
                                  "data-dp-tooltip": _ctx.$t('disconnect'),
                                  "data-dp-position": "left"
                                }, _hoisted_21, 8, _hoisted_19))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.$t('supportedPaymentMethods')), 1)
              ]),
              _hoisted_26
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_base_modal, {
      "modal-id": "modal-payment-provider-settings",
      title: this.activePaymentProvider?.description ?? _ctx.$t('paymentProvider'),
      "no-footer": ""
    }, {
      default: _withCtx(() => [
        (this.activePaymentProvider?.code)
          ? (_openBlock(), _createBlock(_component_PaymentProviderSettings, {
              key: 0,
              "payment-provider-code": this.activePaymentProvider.code,
              "payment-provider-settings": this.getPaymentProviderSettings(this.activePaymentProvider.code),
              onSaved: this.onPaymentProviderSettingsSaved
            }, null, 8, ["payment-provider-code", "payment-provider-settings", "onSaved"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}